export default {
  plans: [],
  selectedPeriod: null,
  selectedPlan: {},
  selectedPaymentMethod: null,
  selectedLocationsCount: 0,
  pricePreview: "0",
  initialChosenPlan: null,
  taxPrice: 0,
  promotionCodes: null,
  promoCode: "",
  promoCodeEdited: false,
  orderCompanyId: null,
  pricePreviewRequest: 0,
  limitsUsage: null,
  currency: null,
  initialPlanIndex: null,
  planChangeType: "no_change",
  checkoutAttemptId: null
};
